import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {TrackingResponse} from "../entities";


@Component({
    selector: 'app-tracking-result',
    templateUrl: './tracking-result.component.html',
    styleUrls: ['./tracking-result.component.scss'],
    standalone: false
})
export class TrackingResultComponent implements OnInit {

  public trackingResponse!: TrackingResponse;
  public searchString!: string;


  constructor(
    private route: ActivatedRoute,
  ) {
  }


  ngOnInit(): void {

    this.route.paramMap.subscribe(paramMap => {
      this.searchString = paramMap.get("searchString") || "";
    })

    this.route.data.subscribe(data => {
      this.trackingResponse = data["trackingResult"];
    });
  }
}
